<!-- Application -->
<router-outlet></router-outlet>
<!-- Notifications -->
<notifier-container></notifier-container>
